import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../firebaseConfig";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";

import "./MobileCategoryPage.css";

const MobileCategoryPage = () => {
  const { categoryName, subcategory } = useParams();

  const [news, setNews] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [visibleCount, setVisibleCount] = useState(20);
  
  useEffect(() => {
    let q;

    if (subcategory) {
      q = query(
        collection(db, "news"),
        where("category", "==", categoryName),
        where("subcategory", "==", subcategory),
        orderBy("timestamp", "desc")
      );
    } else {
      q = query(
        collection(db, "news"),
        where("category", "==", categoryName),
        orderBy("timestamp", "desc")
      );
    }

    const unsubscribeNews = onSnapshot(q, (snapshot) => {
      setNews(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );
    });

    const categoryQuery = query(
      collection(db, "categories"),
      where("name", "==", categoryName)
    );

    const unsubscribeCategory = onSnapshot(
      categoryQuery,
      (snapshot) => {
        if (!snapshot.empty) {
          const data = snapshot.docs[0].data();
          setSubcategories(data.subcategories || []);
        }
      }
    );

    return () => {
      unsubscribeNews();
      unsubscribeCategory();
    };
  }, [categoryName, subcategory]);

  if (news.length === 0) {
    return (
      <div className="mobile-category-page">
        <p>কোনো সংবাদ পাওয়া যায়নি</p>
      </div>
    );
  }

  return (
    <div className="mobile-category-page">

      {/* Category + Subcategory */}
      <div className="mobile-category-top">

        <h2 className="mobile-category-title">
          {categoryName}
        </h2>

        <div className="mobile-subcategory-scroll">
          {subcategories.map((sub, index) => (
            <Link
              key={index}
             to={`/${categoryName}/${sub}/${'general'}`}
              className="mobile-sub-link"
            >
              {sub}
            </Link>
          ))}
        </div>

      </div>

    {/* Lead News */}
<Link
 to={`/${news[0]?.categorySlug || 'general'}/${news[0]?.subcategorySlug || 'general'}/${news[0]?.id}`}
  className="mobile-lead-news"
>
  <img
    src={news[0]?.image}
    alt=""
  />

  <h1>
    {news[0]?.title}
  </h1>
</Link>

      {/* 2 x 2 Grid */}
      <div className="mobile-highlight-grid">

        {news.slice(1, 5).map((item) => (
          <Link
            key={item.id}
         to={`/${item.categorySlug || 'general'}/${item.subcategorySlug || 'general'}/${item.id}`}
            className="mobile-grid-card"
          >
            <img
              src={item.image}
              alt=""
            />

            <p>
              {item.title}
            </p>
          </Link>
        ))}

      </div>

      {/* Remaining News */}
      <div className="mobile-news-list">

       {news.slice(5, 5 + visibleCount).map((item) => (
          <Link
            key={item.id}
        to={`/${item.categorySlug || 'general'}/${item.subcategorySlug || 'general'}/${item.id}`}
            className="mobile-list-item"
          >
            <img
              src={item.image}
              alt=""
            />
            <div className="mobile-list-content">
              <h3>{item.title}</h3>
            </div>

          </Link>
        ))}

      </div>

{news.length > 5 + visibleCount && (
  <div className="mobile-load-more">
    <button
      onClick={() => setVisibleCount(visibleCount + 20)}
      className="mobile-load-more-btn"
    >
      আরও পড়ুন
    </button>
  </div>
)}

    </div>
  );
};

export default MobileCategoryPage;